import { atom } from "recoil";

export const cookieConsentState = atom({
  key: "cookieConsentState",
  default: localStorage.getItem("cookieConsent") === "true",
  effects: [
    ({ onSet, setSelf }) => {
      const syncStorage = () => {
        const val = localStorage.getItem("cookieConsent") === "true";
        setSelf(val);
      };

      // Sync on tab change
      window.addEventListener("storage", syncStorage);

      // Update localStorage when state changes
      onSet((newValue) => {
        localStorage.setItem("cookieConsent", newValue ? "true" : "false");
      });

      return () => {
        window.removeEventListener("storage", syncStorage);
      };
    },
  ],
});
